import styled from 'styled-components';

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 1rem;
`;
